const debug = false;


// lazy loading code syntax highlighter (load prism-js only if there are uninitialized code tags)
export const highlightSyntax = () => {
    const unHighlightedCodeBlocks = document.querySelectorAll('pre:not([class]) code[class*="language-"]');
    // are there any uninitialized code tags (i.e. <pre> with no class containing <code class="language-*">)
    if (unHighlightedCodeBlocks.length) {
        // prism needs < converted to &lt; for it to display HTML tags
        unHighlightedCodeBlocks.forEach(codeBlock => {
            codeBlock.innerHTML = codeBlock.innerHTML.replaceAll('<', '&lt;');
        });

        if (debug) console.debug('detected code blocks that are not syntax highlighted');

        if (typeof window.Prism !== 'undefined') {
            if (debug) console.debug('highlighting syntax (Prism.js has been loaded previously)');
            window.Prism.highlightAll();
        } else {
            if (debug) console.debug('loading the syntax highlighter...');

            const prismPromises = [];
            prismPromises.push(import(/* webpackChunkName: "prismjs" */ 'prismjs/prism.js'));
            /* Prism CSS gets overwritten by ckeditor's code-block module and should be included statically in the root css bundle
            prismPromises.push(import(/* webpackChunkName: "prism-okaidia-theme" 'prismjs/themes/prism-okaidia.css')); */
            prismPromises.push(import(/* webpackChunkName: "prism-autoloader" */ 'prismjs/plugins/autoloader/prism-autoloader'));
            Promise.all(prismPromises).then(() => {
                if (debug) console.debug(`syntax highlighter loaded successfully (${typeof window.Prism})`);
            }).catch(error => {
                throw `loading prism failed with: ${error.message}`;
            });
        }
    } else
        if (debug) console.debug('no uninitialized code tag blocks detected');
}